import React, { useState, Fragment } from 'react'
import CourseListComponent from '../../components/cards/CourseListComponent'
import { WebCourses } from '../../providers/courses/CoursesProvider'

const CourseListSection = ({courses = []}) => {

    return (
        <div className="courses-section">
            {courses.map(course => <CourseListComponent key={course.title} course={course} />)}
        </div>
    )
}

export default CourseListSection
